"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntitySidebarListLink = exports.EntitySidebarListLinkDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var sidebar_link_1 = require("../app/sidebar-link");
var use_app_screen_1 = require("../../hooks/use-app-screen");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var entity_type_plural_icon_label_1 = require("./entity-type-plural-icon-label");
var icon_label_1 = require("../elements/icon-label");
exports.EntitySidebarListLinkDefaultProps = {
  isAll: false,
  isGrouped: false
};
// -------- Styles --------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    min-height: 20px;\n    padding-left: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n\n    ", "\n\n    ", "\n  "], ["\n    min-height: 20px;\n    padding-left: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n\n    ", "\n\n    ", "\n  "])), theme_1.theme.UNIT(6, -1), theme_1.theme.UNIT(2.5), theme_1.theme.UNIT(2.5), function (props) {
    return props.isAll && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      padding-left: ", ";\n    "], ["\n      padding-left: ", ";\n    "])), theme_1.theme.UNIT(5, -1));
  }, function (props) {
    return props.isGrouped && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      border-left: 1px solid ", ";\n      margin-left: ", ";\n      padding-left: ", ";\n    "], ["\n      border-left: 1px solid ", ";\n      margin-left: ", ";\n      padding-left: ", ";\n    "])), theme_1.theme.COLOR('line-sidebar'), theme_1.theme.UNIT(7, -1), theme_1.theme.UNIT(5, -2));
  })
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    color: ", ";\n    ", ";\n    font-weight: 500;\n    font-size: ", ";\n    ", "\n  "], ["\n    color: ", ";\n    ", ";\n    font-weight: 500;\n    font-size: ", ";\n    ", "\n  "])), theme_1.theme.COLOR('primary'), theme_1.theme.FILL('primary'), theme_1.theme.FONT_SIZE(13), function (_a) {
    var isActive = _a.isActive;
    return isActive && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      color: ", ";\n      ", ";\n    "], ["\n      color: ", ";\n      ", ";\n    "])), theme_1.theme.COLOR('dark'), theme_1.theme.FILL('dark'));
  })
});
var AddButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    color: ", ";\n    ", ";\n  "], ["\n    color: ", ";\n    ", ";\n  "])), theme_1.theme.COLOR('primary'), theme_1.theme.FILL('primary'))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(sidebar_link_1.SidebarLink)(templateObject_7 || (templateObject_7 = __makeTemplateObject([""], [""]))),
  AllLabel: (0, styled_components_1.default)(icon_label_1.IconLabel)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Label: (0, styled_components_1.default)(entity_type_plural_icon_label_1.EntityTypePluralIconLabel)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles)
};
My.Container = (0, styled_components_1.default)(sidebar_link_1.SidebarLink)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  ", ";\n\n  &:hover {\n    ", " {\n      color: ", ";\n      ", ";\n    }\n  }\n"], ["\n  ", ";\n\n  &:hover {\n    ", " {\n      color: ", ";\n      ", ";\n    }\n  }\n"])), ContainerStyles, My.Label, theme_1.theme.COLOR('dark'), theme_1.theme.FILL('dark'));
var EntitySidebarListLink = function (props) {
  var className = props.className,
    entityTypeName = props.entityTypeName,
    label = props.label,
    isAll = props.isAll,
    isGrouped = props.isGrouped;
  var screen = (0, use_app_screen_1.useAppScreen)();
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var to = definition.toList();
  var isActive = screen.type === 'list' && screen.entityTypeName === entityTypeName;
  var isChild = !!screen.child;
  return react_1.default.createElement(My.Container, {
    isGrouped: isGrouped,
    isAll: isAll,
    isActive: isActive,
    to: to,
    className: className
  }, react_1.default.createElement(My.Label, {
    isActive: isActive && !isChild,
    entityTypeName: entityTypeName,
    size: "small"
  }, label));
};
exports.EntitySidebarListLink = EntitySidebarListLink;
exports.EntitySidebarListLink.defaultProps = exports.EntitySidebarListLinkDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;